import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

const PageIntroNav = ({
  breadcrumbs = [],
  title,
  subtitle,
  fallbackPath = "/company-settings",
  backLabel = "Back",
  actions = null,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(fallbackPath);
  };

  const showBack = Boolean(backLabel) && breadcrumbs.length === 0;

  return (
    <div className="mb-8">
      {showBack ? (
        <button
          type="button"
          onClick={handleBack}
          className="inline-flex items-center gap-2 text-sm text-[#1234CD] hover:text-[#0D2798] font-medium"
        >
          {backLabel}
        </button>
      ) : null}

      {breadcrumbs.length > 0 && (
        <nav
          className="flex items-center gap-2 flex-wrap text-sm text-gray-600"
          aria-label="Breadcrumb"
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;

            return (
              <React.Fragment key={`${crumb.label}-${index}`}>
                {index > 0 ? (
                  <FiChevronRight
                    size={14}
                    className="text-gray-400"
                  />
                ) : null}
                {crumb.path && !isLast ? (
                  <Link
                    to={crumb.path}
                    className="hover:text-[#1234CD] font-medium"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span
                    className={
                      isLast ? "text-gray-900 font-semibold" : "text-gray-600"
                    }
                  >
                    {crumb.label}
                  </span>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      )}

      {(title || subtitle || actions) && (
        <div className="mt-3">
          {(title || actions) && (
            <div className="flex items-center justify-between gap-4 flex-wrap">
              {title ? (
                <h1 className="text-xl font-semibold text-black leading-tight">
                  {title}
                </h1>
              ) : (
                <div />
              )}
              {actions ? <div className="shrink-0">{actions}</div> : null}
            </div>
          )}
          {subtitle ? (
            <p className="text-xs text-gray-500 mt-0.5 max-w-2xl leading-snug">
              {subtitle}
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PageIntroNav;
